import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export const GlobalFilter = ({ setFilter }) => {
  const { t } = useTranslation();

  return (
    <span className="span-search">
      <input
        id="globalFilter"
        placeholder={t("Pesquisa")}
        className="input-search"
        onChange={(e) => setFilter(e.target.value)}
      />
    </span>
  );
};
GlobalFilter.propTypes = {
  setFilter: PropTypes.func.isRequired,
};
export default GlobalFilter;
